var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFivePages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 100,
    viewBox: "0 0 94 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.159131 0V77.723C19.9962 49.3745 53.3141 29.4195 87.4616 24.3549L44.6128 0H0.159131ZM65.2575 33.9467C38.6634 43.3395 14.4808 61.6749 0.000212059 85.149V92.2222C23.9917 68.754 58.7728 55.0942 92.1634 55.3321L65.2575 33.9467ZM70.6807 61.0343C44.1125 65.59 18.2789 78.6321 0 97.8323V99.9998H12.5005C36.6673 86.1952 65.7917 79.9339 93.0193 82.9884L70.6807 61.0343ZM70.2026 86.4964C53.2027 87.735 36.1629 92.3814 20.8486 100H77.3763L70.2026 86.4964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFivePages);
export default __webpack_public_path__ + "static/media/FivePages.059ee59784dc926308735a7903ce7069.svg";
export { ForwardRef as ReactComponent };